module.exports = __webpack_public_path__ + "328737bace5e1e9997b0367d4e788ac1.png";